import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import { useQuery } from "@tanstack/react-query";
import { odataFetch } from "../../lib/odata-fetch";
import { ReworkCode } from "../../odata/appu4dm/AppU4DMModel";
import { qReworkCode, QReworkCode } from "../../odata/appu4dm/QAppU4DM";
import { useWorkOrder } from "../work-order/use-work-order";
import { ncKeys } from "./nc-keys";

export function useNCReworkCodes(failureNIds: string[]) {
  const { workOrder } = useWorkOrder();
  const materialNId = workOrder?.FinalMaterial.Material.NId;

  const { data, ...query } = useQuery({
    queryKey: ncKeys.getReworkCodes(failureNIds, materialNId),
    queryFn: ({ meta }) =>
      fetchNCReworkCodes(failureNIds, materialNId!, meta!.token!),
    enabled: ({ meta }) =>
      !!meta?.token && failureNIds.length !== 0 && !!materialNId,
  });

  return {
    reworkCodes: data?.value,
    ...query,
  };
}

async function fetchNCReworkCodes(
  failureNIds: string[],
  materialNId: string,
  token: string
) {
  const builder = createQueryBuilderV4("ReworkCode", new QReworkCode())
    .filter(
      qReworkCode.FailureNId.in(...failureNIds).and(
        qReworkCode.DM_MaterialNId.eq(materialNId)
      )
    )
    .expand("ProcessId");

  return odataFetch<ReworkCode>({ builder, token });
}
